/**
 * meterLook.js — every number that decides how the /rate corpus meter MOVES.
 *
 * ══════════════════════════════════════════════════════════════════════
 * 🔴 THIS FILE EXISTS TO BE EDITED DURING A TUNING PASS, exactly like
 * clipLook.js. Ben: "show on the bar graph climbing slowly also." How slowly is
 * a judgement made looking at the page on a phone, not a value anybody can
 * derive, so the dials are here together rather than scattered through the
 * component: one file open, save, look, save again.
 *
 * 🔴 NOTHING HERE CHANGES A NUMBER, ONLY ITS ARRIVAL. The percentile, the
 * marker's position and the bar heights are all computed from the corpus and
 * are untouched by every value below. A bad dial here makes the meter ugly or
 * slow; it cannot make it report something false.
 *
 * 🔴 REDUCED MOTION IGNORES ALL OF IT. Under prefers-reduced-motion the meter
 * renders fully settled on the first paint - marker in place, number at its
 * value, every bar at full height, no transitions at all. That path must stay
 * reachable no matter what these are set to.
 * ══════════════════════════════════════════════════════════════════════
 */
export const METER_LOOK = {
  /**
   * How long the marker takes to reach its place, and how long the number
   * takes to count up to its value. ONE duration for both, so they arrive
   * together rather than one waiting on the other.
   *
   * 🔴 2200ms IS DELIBERATELY SLOW. At 900ms the sweep was over before a reader
   * had finished the sentence above it, so the one moment the page earns - your
   * team walking up through nine hundred real ones - was something people
   * missed. Slow enough to watch is the whole point of the meter.
   */
  sweepMs: 2200,

  /**
   * How long ONE histogram bar takes to grow from nothing to its height.
   *
   * The bars rise WITH the sweep rather than after it: the corpus and the
   * team's place in it build together, so the meter reads as one movement
   * instead of a chart that appears and then gets a marker.
   */
  barRiseMs: 700,

  /**
   * The delay added per bar, left to right. Bar i starts at i × this.
   *
   * ⚠️ THE ARITHMETIC THE THREE DIALS OWE EACH OTHER: the last bar finishes at
   * barStaggerMs × (bars − 1) + barRiseMs, and that should land near sweepMs so
   * the marker and the far end of the corpus settle at the same moment. At the
   * shipped 30 bars: 50 × 29 + 700 = 2150ms against a 2200ms sweep. Change one
   * and check that sum; nothing enforces it, because forcing it would take the
   * stagger away as a dial, which is the one Ben most wants to try.
   */
  barStaggerMs: 50,

  /**
   * The curve the marker and the bars share.
   *
   * ⚠️ THE COUNT-UP MIRRORS THIS IN JS, it does not read it: a rAF loop cannot
   * consume a CSS timing function, so CorpusMeter applies a cubic ease-out
   * (1 − (1 − p)³), which is the same shape as the bezier below. Changing this
   * to a materially different curve means changing that mirror too, or the
   * number and the marker stop agreeing anywhere but at the two ends.
   */
  easing: "cubic-bezier(0.16, 1, 0.3, 1)",
};

export default METER_LOOK;
